import { getAddonValue } from './format';

export function getCaption(language, CAPTIONS, type, status) {
  if (!language) {return null;}

  const captionValue = getAddonValue(CAPTIONS(type), language, null);

  const captionType = type === 'SRT_CAPTIONS' ? 'SRT' : 'BURN-IN';

  return captionValue ? {
    captionValue,
    language,
    type: captionType,
    status
  } : void 0;
}


export default function getCaptions(CAPTIONS) {
  return (addons) => {
    const { status, value } = addons && addons.BURN_IN_CAPTIONS || {};
    const srtValue = addons && addons.SRT_CAPTIONS || [];

    const srtValues = srtValue.map((srt) => getCaption(srt.value, CAPTIONS, 'SRT_CAPTIONS'));

    const burnInCaption = getCaption(value, CAPTIONS, 'BURN_IN_CAPTIONS', status);

    return [burnInCaption, ...srtValues].filter(Boolean);
  };
}